import type { MedicalResultSource } from '../../../../services/MedicalResultsService';

export const shouldIncludeDocumentExtractionV2 = ({
  source,
  isDocumentExtractionV2Enabled,
}: {
  source?: MedicalResultSource;
  isDocumentExtractionV2Enabled: boolean;
}) => source === undefined && isDocumentExtractionV2Enabled;
